import {
  ApiOutlined,
  AlertOutlined,
  AuditOutlined,
  BarChartOutlined,
  ApartmentOutlined,
  ClearOutlined,
  CloudOutlined,
  CloudServerOutlined,
  DashboardOutlined,
  DatabaseOutlined,
  ExperimentOutlined,
  FundOutlined,
  HistoryOutlined,
  LockOutlined,
  ReadOutlined,
  PlaySquareOutlined,
  ProfileOutlined,
  SettingOutlined,
  SwapOutlined,
  TeamOutlined,
} from '@ant-design/icons'
import type { ReactNode } from 'react'

import type { Role } from '../api/types'

export interface NavItem {
  key: string
  label: string
  icon: ReactNode
  role: Role
  /** Hiện cho role transcoder (mặc định ẩn). */
  transcoder?: boolean
  /** Chỉ role transcoder thấy (trang của riêng user). */
  transcoderOnly?: boolean
}

export const NAV_ITEMS: NavItem[] = [
  { key: '/', label: 'Tổng quan', icon: <DashboardOutlined />, role: 'viewer' },
  { key: '/jobs', label: 'Jobs', icon: <PlaySquareOutlined />, role: 'viewer', transcoder: true },
  { key: '/stats', label: 'Thống kê', icon: <BarChartOutlined />, role: 'viewer', transcoder: true },
  { key: '/queues', label: 'Queue', icon: <ApartmentOutlined />, role: 'viewer' },
  { key: '/alerts', label: 'Cảnh báo', icon: <AlertOutlined />, role: 'viewer' },
  { key: '/profiles', label: 'Profile', icon: <ProfileOutlined />, role: 'viewer', transcoder: true },
  { key: '/nodes', label: 'Node', icon: <CloudServerOutlined />, role: 'viewer' },
  { key: '/codecs', label: 'Codec hỗ trợ', icon: <ExperimentOutlined />, role: 'viewer', transcoder: true },
  { key: '/api-docs', label: 'Tài liệu API', icon: <ReadOutlined />, role: 'viewer', transcoder: true },
  { key: '/my-storages', label: 'Lưu trữ của tôi', icon: <CloudOutlined />, role: 'viewer', transcoder: true, transcoderOnly: true },
  { key: '/storage', label: 'Lưu trữ & xoá', icon: <ClearOutlined />, role: 'operator' },
  { key: '/storages', label: 'Storage', icon: <DatabaseOutlined />, role: 'admin' },
  { key: '/drm', label: 'DRM / Key provider', icon: <LockOutlined />, role: 'admin' },
  { key: '/key-pools', label: 'Pool key DRM', icon: <LockOutlined />, role: 'admin' },
  { key: '/api-clients', label: 'API clients', icon: <ApiOutlined />, role: 'operator' },
  { key: '/legacy-requests', label: 'Legacy requests', icon: <HistoryOutlined />, role: 'operator' },
  { key: '/request-stats', label: 'Thống kê request', icon: <FundOutlined />, role: 'operator' },
  { key: '/legacy-settings', label: 'Tương thích API cũ', icon: <SwapOutlined />, role: 'admin' },
  { key: '/users', label: 'Người dùng', icon: <TeamOutlined />, role: 'admin' },
  { key: '/settings', label: 'Cấu hình', icon: <SettingOutlined />, role: 'admin' },
  { key: '/audit-logs', label: 'Audit log', icon: <AuditOutlined />, role: 'admin' },
]
